<template>
    <div :style="{'height':clientHeight-90+'px'}">
        <div class="m-portlet m-b-10" :style="{'height':(80)+'px'}">
            <div class="m-portlet__body">
                <el-form label-width="100px" style="width: 1200px">
                    <el-row :gutter="10">
                        <el-col :span="6">
                            <el-form-item label="筛选仓库">
                                <el-select v-model="filter.storeId" placeholder="仓库"
                                           filterable remote
                                           :remote-method="handelSearchStore"
                                           @change="handleChange()">
                                    <el-option
                                            v-for="item in warehouses"
                                            :key="item.id"
                                            :label="item.name"
                                            :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="筛选序列号">
                                <el-select v-model="filter.serialId" placeholder="序列号" clearable
                                           filterable remote
                                           :remote-method="handelSearchBySerialId"
                                           @change="handleList()">
                                    <el-option
                                            v-for="item in serials"
                                            :key="item.id"
                                            :label="item.serial_id"
                                            :value="item.serial_id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
        </div>
        <div class="m-portlet m-b-10" :style="{'height':(260)+'px'}">
            <div class="m-portlet__body" :style="{'height':250+'px'}" v-loading="loading">
                <el-row :gutter="10">
                    <el-col :span="16">
                        <el-table
                                :data="shops"
                                style="width: 100%"
                                size="middle"
                                :height="200"
                        >
                            <el-table-column prop="name" label="商品名"></el-table-column>
                            <el-table-column prop="total" label="库存总数"></el-table-column>
                            <el-table-column prop="dispatch" label="待交付"></el-table-column>
                            <el-table-column prop="canRent" label="可用数量"></el-table-column>
                        </el-table>
                    </el-col>
                    <el-col :span="8">
                        <div style="position: absolute;top: 40%;right: 5%">
                            <el-button round @click="handleView()" type="primary" style="height: 50px;width: 150px">教师分配清单</el-button>
                        </div>

                    </el-col>
                </el-row>
            </div>
        </div>
        <div class="m-portlet" :style="{'height':(clientHeight-460)+'px'}">
            <div class="m-portlet__body" :style="{'height':clientHeight-550+'px'}" v-loading="loading">
                <el-table
                        :data="orderTeacherDistributions"
                        style="width: 100%"
                        size="middle"
                        :height="clientHeight-550"
                >
                    <el-table-column prop="name" label="商品名称" min-width="15%"></el-table-column>
                    <el-table-column prop="description" label="描述" min-width="10%"></el-table-column>
                    <el-table-column prop="serial_id" label="序列号" min-width="10%"></el-table-column>
                    <el-table-column prop="sign" label="内部编号" min-width="10%"></el-table-column>
                    <el-table-column prop="created_at" label="首次入库时间" min-width="15%"></el-table-column>
                    <el-table-column prop="statusName" label="状态" min-width="10%"></el-table-column>
                    <el-table-column prop="price" label="价值" min-width="10%"></el-table-column>
                    <el-table-column label="操作" min-width="20%">
                        <template slot-scope="scope">
                            <el-button size="mini"
                                       @click="handleCargo(scope.row.id)">调货
                            </el-button>
                            <el-button size="mini"
                                       @click="handleGrant(scope.row.name_id,scope.row.id)">发放
                            </el-button>
                            <el-button size="mini"
                                       @click="handleGetShopMsg(scope.row.id)">查看
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="m-portlet__foot">
                    <!--分页-->
                    <div class="text-center">
                        <el-pagination
                                @size-change="handleSizeChange"
                                @current-change="handleCurrentChange"
                                :current-page="currentPage"
                                :page-sizes="[10, 20, 50, 100]"
                                :page-size="10"
                                layout="total, sizes, prev, pager, next, jumper"
                                :total="total">
                        </el-pagination>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import store from '@/store'
    export default {
        name: "LeaseInventoryList",
        data() {
            return {
                teacherDistributions:[],
                shops:[],
                warehouses:[],
                students:[],
                invoices:[],
                serials:[],
                warehouse_id:'',
                filter:{
                    date:'',
                    serialId:'',
                    sign:'',
                    categoryId:'',
                    storeId:''
                },
                total: 0,
                currentPage: 1,
                currentPageSize: 10,
                loading:false,
                Dialog_TeacherCargoShop:{
                    warehouses:[],
                    multipleSelection:[],
                    total: 0,
                    currentPage: 1,
                    currentPageSize: 10,
                },
                Dialog_GrantShop:{
                    grantInvoices:[],
                    multipleSelection:[],
                    total: 0,
                    currentPage: 1,
                    currentPageSize: 10,
                    filter:{
                        employee_id:'',
                    }
                },
                Dialog_TeacherShopList:{
                    teacherShops:[],
                    multipleSelection:[],
                    total: 0,
                    currentPage: 1,
                    currentPageSize: 10,
                    filter:{
                        employee_id:'',
                    }
                },
            }
        },
        created() {
            this.handelSearchStore();
            this.handelSearchBySerialId();
            this.handleList()
            this.handleCountByShopName();
        },
        computed: {
            clientHeight() {
                return this.$store.state.config.clientHeight
            },
            orderTeacherDistributions: function () {
                return this._.orderBy(this.teacherDistributions, 'id', 'asc');
            }
        },
        methods: {
            handleList(currentPage = 1){
                if (currentPage === 1) {
                    this.currentPage = 1
                }
                this.loading = true;
                this.$axios.get(store.state.server + '/getTeacherReserveList?storeId=' + this.filter.storeId+
                    '&serialId='+this.filter.serialId +
                    '&page='+this.currentPage +
                    '&limit=' + this.currentPageSize
                ).then((response) => {
                    if (response.data.code == '0000') {
                        if (Object.keys(response.data.content.list).length !== 0) {
                            this.teacherDistributions=response.data.content.list;
                        } else {
                            this.teacherDistributions = new Object();
                        }
                        this.total=response.data.content.total
                        this.loading = false;
                    }
                }).catch((res) => {
                    this.$message({
                        type: 'error',
                        message: res.response.data.content
                    });

                })
            },
            handleCountByShopName(){
                this.$axios.get(store.state.server + '/teacherReserveCount?storeId=' + this.filter.storeId
                ).then((response) => {
                    if (response.data.code == '0000') {
                        this.shops=response.data.content.shopNames
                    }
                }).catch((res) => {
                    this.$parentInfo.
                    this.$message({
                        type: 'error',
                        message: res.response.data.content
                    });

                })
            },
            handleChange(){
                this.handleList();
                this.handleCountByShopName();
            },
            handleCargo(id){
                this.$Win.openModal('Dialog_TeacherCargoShop', 700, 400, '调货仓库',{'shopId':id,'storeId':this.filter.storeId});
            },
            handleGrant(name_id,shop_id){
                this.$Win.openModal('Dialog_TeacherGrantShop', 800, 400, '发放',{'name_id':name_id,'shopId':shop_id});
            },
            handleView(){
                this.$Win.openModal('Dialog_TeacherShopList', 800, 400, '教师分配清单');
            },
            handleGetShopMsg(id){
                this.$Win.openModal('Dialogs_GetShopMsg', 400, 400, '查看',{'shopId':id});
            },
            handleSizeChange(val) {
                this.currentPageSize = val;
                this.handleList(this.currentPage, this.currentPageSize)
            },
            handleCurrentChange(val) {
                this.currentPage = val;
                this.handleList(this.currentPage, this.currentPageSize)
            },
            handelSearchStore(val=''){
                this.$axios.get(store.state.server + '/searchByStoreName?storeName=' +val+'&type=3').then((response) => {
                    if (response.data.code == '0000') {
                        this.warehouses=response.data.content.storeName
                        if(!this.filter.storeId){
                            this.filter.storeId=this.warehouses[0].id
                            this.handleChange()
                        }
                    }
                }).catch((res) => {
                    this.$message({
                        type: 'error',
                        message: res.response.data.content
                    });

                })
            },
            handelSearchBySerialId(val=''){
                this.$axios.get(store.state.server + '/searchBySerialId?serialId=' +val).then((response) => {
                    if (response.data.code == '0000') {
                        this.serials=response.data.content.shops
                    }
                }).catch((res) => {
                    this.$message({
                        type: 'error',
                        message: res.response.data.content
                    });

                })
            },
        }
    }
</script>

<style scoped>

</style>